import { render, staticRenderFns } from "./EditLabourerPaymentItemPage.vue?vue&type=template&id=2d8cf7a6&scoped=true&"
import script from "./EditLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./EditLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8cf7a6",
  null
  
)

export default component.exports